import styled from "styled-components";

import { fontSizes } from "../../shared/styles/typography";

export const Body = styled.div`
  padding: 16px;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
`;

export const Lead = styled.p`
  margin: 0 0 20px;
  font-size: ${fontSizes.sm}px;
  line-height: 1.5;
  color: var(--color-text-complement, #64748b);
`;
